<template>
  <section role="footer" class="footer" id="footer">
    <div class="container" @click="mostraRodape()">
      <div class="col-sm-3 hidden-xs info-content">
        <div class="info">
          <h4>PROBLEMAS</h4>
            <!--test-->
          <p>
            Abra um SAU para<br />solucionar seu problema.<br />
            <a href="https://egov.santos.sp.gov.br/sau">
              egov.santos.sp.gov.br/sau
            </a>
          </p>
        </div>
      </div>
      <div class="col-sm-3 hidden-xs info-content">
        <div class="info">
          <h4>DEGEPAT</h4>
          <p>
            Rua QUINZE DE NOVEMBRO, 108<br />
            Centro - Santos/SP<br />
            CEP 11010-150<br />
            Tel. (13) 3213-7166<br />
            <a href="mailto:degepat@santos.sp.gov.br">
              degepat@santos.sp.gov.br
            </a>
          </p>
        </div>
      </div>
      <div class="col-sm-3 hidden-xs info-content">
        <div class="info">
          <h4>CONTROLADORIA</h4>
          <p>
            Paço Municipal<br />
            Praça Visconde de Mauá, s/n<br />
            3º andar, sala 302<br />
            Cep 11010-900<br />
            <a href="mailto:declaracaodebens@santos.sp.gov.br">
              declaracaodebens@santos.sp.gov.br
            </a>
          </p>
        </div>
      </div>
      <div class="row row-field">
        <div class="col-xs-6 visible-xs info-content">
          <div class="info">
            <h4>PROBLEMAS</h4>
            <p>
              Abra um SAU para<br />solucionar seu problema.<br />
              <a href="https://egov.santos.sp.gov.br/sau">
                egov.santos.sp.gov.br/sau
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="row row-field">
        <div class="col-xs-6 visible-xs info-content">
          <div class="info">
            <h4>DEGEPAT</h4>
            <p>
              Rua Riachuelo, 104<br />
              Centro - Santos/SP<br />
              Cep 11010-020<br />
              Tel. (13) 3213-7166<br />
              <a href="mailto:degepat@santos.sp.gov.br">
                degepat@santos.sp.gov.br
              </a>
            </p>
          </div>
        </div>
        <div class="col-xs-6 visible-xs info-content">
          <div class="info">
            <h4>IPREV</h4>
            <p>
              Rua Dr. Assis Corrêa, 20<br />
              Gonzaga - Santos/SP<br />
              Cep 11055-310<br />
              Tel. (13) 3202-9099<br />
              <a href="mailto:degepat@santos.sp.gov.br">
                iprev@santos.sp.gov.br
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-xs-12" style="padding-top: 15px">
        <p style="text-align: center">
          Prefeitura de Santos - Secretaria de Gestão (SEGES) - Departamento de
          Gestão de Tecnologia da Informação e Comunicação (DETIC) - Versão:
          3.0.0 - 2019
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'rodape',
  methods: {
    mostraRodape() {
      const html = document.querySelector('html').clientHeight;
      const tela = window.innerHeight;
      const posicao = window.innerHeight + window.scrollY;

      if (tela === posicao) {
        window.scrollTo({ top: html, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style scoped>
h4 {
  color: #c1d1c1;
  font-weight: 400;
  margin-bottom: 18px;
  cursor: pointer;
}
p {
  line-height: 1.65em;
}
.footer {
  background: #00302e;
  font-size: 12px;
  width: 100%;
  color: #c1d1c1;
  text-align: left;
  padding-top: 10px;
  padding-bottom: 10px;
  position: absolute;
  left: 0;
  top: 100%;
}
.info-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.info {
  margin-left: unset;
  margin-right: unset;
}

@media screen and (min-width: 768px) {
  .info {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?1876c45c